// format phone number.
// '375291111111' -> '+375 29 111 11 11' with template '+XXX XX XX-XX-XX'
// '375291' -> '+375 29 1' with template '+XXX XX XX-XX-XX'
export const DEFAULT_PHONE_MASK = '+000 000000000';

export const parsePhone = (
  number?: string | null,
  phoneTemplate: string = DEFAULT_PHONE_MASK
): string => {
  if (!number) {
    return '';
  }
  const chunks = phoneTemplate.replace(/[-]/g, ' ').slice(1).split(' ');

  let start = 0;
  const formatNumber = chunks.reduce((acc, chunk, index) => {
    const x = number.slice(start, start + chunk.length);
    start += chunk.length;
    return [acc, x].filter(Boolean).join(' ');
  }, '');
  return `+${formatNumber}${number.slice(start)}`;
};

export const replacePhoneTemplate = (phoneTemplate?: string, replaceValue = '0'): string => {
  if (!phoneTemplate) {
    return DEFAULT_PHONE_MASK;
  }
  return phoneTemplate.replace(/[-]/g, ' ').replace(/[X]/g, replaceValue);
};

export const clearPhoneNumber = (phoneNumber?: string): string => {
  if (!phoneNumber) {
    return '';
  }
  return phoneNumber.replace(/[^\d]/g, '');
};
